import qs from 'querystring';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const SIGNUP_URL = `${BASE_URL}/signup`;

class GuestBillingService {
  register = (username, password) => {
    const payload = {
      userName: username,
      newPassword: password,
    };

    return this.submitRequest(payload);
  };

  changeEmail = (email) => {
    const payload = {
      email,
      isGuestSignup: true,
    };

    return this.submitRequest(payload);
  };

  submitRequest = (payload) =>
    ApiService.post(
      SIGNUP_URL, {
        data: qs.stringify(payload),
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
      }
    );
}

export default new GuestBillingService();


